import { render, staticRenderFns } from "./ReporteRiesgos.vue?vue&type=template&id=03ca849a&scoped=true&"
import script from "./ReporteRiesgos.vue?vue&type=script&lang=js&"
export * from "./ReporteRiesgos.vue?vue&type=script&lang=js&"
import style0 from "./ReporteRiesgos.vue?vue&type=style&index=0&id=03ca849a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ca849a",
  null
  
)

export default component.exports